'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select as AriaKitSelect, SelectHeading, SelectItem, SelectLabel, SelectList, SelectPopover, SelectProvider, } from '@ariakit/react';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { focusOutline } from '../../utility-classes';
import { IconButton } from '../IconButton/IconButton';
import { Carat, RotateClockwise } from '../Icons';
import { InputLabel } from '../Input/InputLabel';
import { sharedInputStyles } from '../Input/styles';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { TypeStyleHeadlineMicro } from '../TypeStyle';
const StyledSelect = styled((props) => {
    return _jsx(AriaKitSelect, { ...props });
}) `
  ${sharedInputStyles};
`;
const StyledSelectedValue = styled.span `
  flex-grow: 1;
  flex-shrink: 1;
  text-align: left;
`;
const StyledSelectArrow = styled(({ className }) => {
    return (_jsx(IconButton, { forwardedAs: 'span', size: 'small', variant: 'black-on-white-no-border', className: className, flushTop: true, flushLeft: true, flushRight: true, flushBottom: true, ariaLabel: '', children: _jsx(Carat, { rotateClockwise: RotateClockwise.Quarter }) }));
}) `
  flex-grow: 0;
  flex-shrink: 0;
`;
const StyledSelectPopover = styled(SelectPopover) `
  z-index: ${o => o.theme.zIndex.popovers};
  display: flex;
  max-height: min(var(--popover-available-height, 240px), 240px);
  flex-direction: column;
  overflow: auto;
  overscroll-behavior: contain;
  border-radius: ${o => o.theme.spacing(1)};
  border-width: 1px;
  border-style: solid;
  border-color: ${o => o.theme.color.stroke.neutral.border.interaction.secondary.on.background};
  background-color: ${o => o.theme.color.fill.background};
  padding: ${o => o.theme.spacing(2)};
  color: ${o => o.theme.color.text.primary.on.background};
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);

  ${focusOutline};
`;
const StyledSelectHeading = styled(SelectHeading) `
  display: flex;
  cursor: default;
  scroll-margin: ${o => o.theme.spacing(2)};
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  border-radius: ${o => o.theme.spacing(0.5)};
  padding: ${o => o.theme.spacing(2)};
  outline: none !important;
`;
const StyledSelectItem = styled(SelectItem) `
  display: flex;
  cursor: default;
  scroll-margin: ${o => o.theme.spacing(2)};
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  border-radius: ${o => o.theme.spacing(0.5)};
  padding: ${o => o.theme.spacing(2)};
  outline: none !important;

  &[aria-disabled='true'] {
    opacity: 0.5;
  }

  &[data-active-item] {
    background-color: ${o => o.theme.color.button.primary.fill.on.background};
    color: ${o => o.theme.color.button.primary.content.on.background};
  }
`;
export const Select = ({ name, children, className, label, value, onChange, onBlur, errorId, isInvalid, renderSelectValue, renderLabel, heading, required, }) => {
    const anchorRef = useRef(null);
    return (_jsxs(SelectProvider, { value: value, setValue: onChange, children: [renderLabel ? (renderLabel()) : label ? (_jsx(InputLabel, { asTag: 'span', required: required, children: _jsx(SelectLabel, { children: label }) })) : heading ? (_jsx(ScreenReaderOnly, { children: _jsx(SelectLabel, { children: heading }) })) : null, _jsxs(StyledSelect, { "$isInvalid": isInvalid, "$isEmpty": value !== '', className: className, "aria-errormessage": errorId, ref: anchorRef, onBlur: onBlur, required: true, name: name, children: [_jsx(StyledSelectedValue, { children: renderSelectValue(value) }), _jsx(StyledSelectArrow, {})] }), _jsxs(StyledSelectPopover, { gutter: 4, sameWidth: true, fixed: true, portal: false, preserveTabOrder: true, preserveTabOrderAnchor: anchorRef.current, children: [heading ? (_jsx(StyledSelectHeading, { children: _jsx(TypeStyleHeadlineMicro, { children: heading }) })) : null, _jsx(SelectList, { children: children })] })] }));
};
export const SelectOption = ({ children, className, value }) => {
    return (_jsx(StyledSelectItem, { value: value, className: className, children: children }));
};
//# sourceMappingURL=Select.js.map